import LandingImage from "../../../assets/images/landing-image.png";
import {
  Container,
  ContentImage,
  HeroImage,
  MainContent,
  HeroContent,
  HighlightedText,
  HeroTitle,
  CtaButton,
} from "./style";
import routeConstant from "../../../utils/routeConstant";
import {useSearchParams} from "react-router-dom";
const HeroSection = () => {
  const [searchParms] = useSearchParams();
  const stringifySearchParams = searchParms.toString();

  return (
    <Container>
      <HeroContent>
        <MainContent>
          <HeroTitle>
            The Ultimate Platform for Marketing Agencies and{" "}
            <HighlightedText>AD WorkFlow</HighlightedText>
          </HeroTitle>
        </MainContent>
        <CtaButton to={`/${routeConstant.signup}${stringifySearchParams ? "?" + stringifySearchParams : ""}`}>Get Started</CtaButton>
      </HeroContent>
      <HeroImage>
        <ContentImage src={LandingImage} alt="Platform illustration" />
      </HeroImage>
    </Container>
  );
};

export default HeroSection;
